import TranslationProvider from '@/provider/translations.js'

export const canDelegateCC = (compiledPoll, modalBulkActionsPayload) => {
  if (
    modalBulkActionsPayload['cc'] &&
    (
      compiledPoll['attributes']['gec.involved_subject.main_contractor'] === modalBulkActionsPayload['cc'].reference ||
      compiledPoll['attributes']['gec.involved_subject.construction_site_manager'] === modalBulkActionsPayload['cc'].reference
    )
  ) {
    return TranslationProvider.getTrans('app.massive_error_delegate_cc.already_cc')
  }

  if (!compiledPoll['enabledActions']['editDelegatedCC']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_cc')
  }

  if (!compiledPoll['enabledActions']['settings']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_cc')
  }
  return null
}

export const canDelegateDT = (compiledPoll, modalBulkActionsPayload) => {
  if (
    modalBulkActionsPayload['dt'] &&
    (
      compiledPoll['attributes']['gec.involved_subject.construction_site_manager'] === modalBulkActionsPayload['dt'].reference ||
      compiledPoll['attributes']['gec.involved_subject.main_contractor'] === modalBulkActionsPayload['dt'].reference
    )
  ) {
    return TranslationProvider.getTrans('app.massive_error_delegate_dt.already_dt')
  }

  if (!compiledPoll['enabledActions']['editDelegatedDT']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_dt')
  }

  if (!compiledPoll['enabledActions']['settings']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_dt')
  }

  return null
}
